import React, { useEffect, useState } from "react";
import ServiceSelectTag from "./select/ServiceSelectTag";

export default function HomePageAppointment({ ServiceNames }) {
  // FORM STATE FALSE IS NOT SUBMITTED
  const [formState, setFormState] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    serviceIntrested: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    // FORM WITHOUT LEFT SIDE CONTENT
    <section className="prt-row prt-bg bg-base-darkblack prt-bgimage-yes bg-img2 appointment-section position-relative clearfix">
      <div className="prt-row-wrapper-bg-layer prt-bg-layer bg-base-darkblack"></div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* section title */}
            <div className="section-title title-style-center_text">
              <div className="title-header">
                <h2 className="title">Explain your health problem</h2>
              </div>
            </div>
            {/* section title end*/}
          </div>
        </div>
        <div className="row mt-25">
          <div className="col-lg-12">
            <div className="prt-appointment-block">
              <form
                action="#"
                className="query_form wrap-form clearfix"
                method="post"
              >
                <div className="row">
                  <div className="col-lg-8 col-md-12">
                    <div className="row">
                      <div className="col-md-6">
                        <span className="text-input">
                          <input
                            name="name"
                            type="text"
                            placeholder="Name *"
                            onChange={handleChange}
                            required
                          />
                        </span>
                      </div>
                      <div className="col-md-6">
                        <span className="text-input">
                          <input
                            name="email"
                            type="email"
                            placeholder="Email *"
                            onChange={handleChange}
                            required
                          />
                        </span>
                      </div>
                      <div className="col-md-6">
                        <span className="text-input">
                          <input
                            name="phone"
                            type="text"
                            placeholder="Phone *"
                            onChange={handleChange}
                            required
                          />
                        </span>
                      </div>
                      <ServiceSelectTag
                        ServiceNames={ServiceNames}
                        handleChange={handleChange}
                        value={formData.serviceIntrested}
                      />
                      <div className="col-md-6">
                        <span className="text-input">
                          <input
                            name="date"
                            type="date"
                            placeholder="Select Date *"
                            onChange={handleChange}
                            required
                          />
                        </span>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <span className="text-input">
                          <textarea
                            name="message"
                            rows="4"
                            placeholder="Message*"
                            onChange={handleChange}
                            required
                          ></textarea>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 text-center">
                    <button
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-darkcolor"
                      type="submit"
                    >
                      Make an appointment
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
